import { TermsConditionsComponent } from './components/shared/static-pages/terms-conditions/terms-conditions.component';
import { SuggestionsComponent } from './components/shared/static-pages/suggestions/suggestions.component';
import { ContactFormComponent } from './components/shared/static-pages/contact-form/contact-form.component';
import { Injectable, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/**
 * Guards
 */
import { AuthGuard } from './guards/auth.guard';

/**
 * Components
 */
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/shared/login/login.component';
import { EventComponent } from './components/event/event.component';
import { SearchComponent } from './components/search/search.component';
import { CategoryPageComponent } from './components/categories/category-page/category-page.component';
import { NotFoundPageComponent } from './components/shared/not-found-page/not-found-page.component';
import { PrivacyComponent } from './components/shared/static-pages/privacy/privacy.component';
import { PageOwnerComponent } from './components/page-owner/page-owner.component';
import { FaqsComponent } from './components/shared/static-pages/faqs/faqs.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { WhoWeAreComponent } from './components/who-we-are/who-we-are.component';
import { CityblogComponent } from './components/blog/cityblog/cityblog.component';
import { DetailPodsComponent } from './components/blog/detail-pods/detail-pods.component';
import { RegisterComponent } from './components/shared/register/register.component';
import { IsuserGuard } from './guards/isuser.guard';
import { AdminGuard } from './guards/admin.guard';
import { CheckoutGuard } from './guards/checkout.guard';
import { CheckoutPageComponent } from './components/checkout/checkout-page/checkout-page.component';
import { WaitingPayComponent } from './components/checkout/waiting-pay/waiting-pay.component';
import { ConfirmPayComponent } from './components/checkout/confirm-pay/confirm-pay.component';
import { ProfileComponent } from './components/profile/profile/profile.component';
import { FavoritesComponent } from './components/profile/favorites/favorites.component';
import { EditProfileComponent } from './components/profile/config/edit-profile/edit-profile.component';
// Ruta comentada en el perfil (la pantalla no funciona); el componente sigue declarado en app.module.
// import { InteresesComponent } from './components/profile/config/intereses/intereses.component';
import { NotificationsComponent } from './components/profile/config/notifications/notifications.component';
import { MyMembershipComponent } from './components/profile/config/my-membership/my-membership.component';
import { AbonoCardComponent } from './components/profile/config/my-membership/abono-card/abono-card.component';
import { SeasonPassSignupComponent } from './components/season-pass-signup/season-pass-signup.component';
// Pantalla de plazo cerrado: desactivada al reabrir el 05-10-2026, ver la ruta 'alta-abono'.
// import { SeasonPassSignupClosedComponent } from './components/season-pass-signup-closed/season-pass-signup-closed.component';
// Renovación por carné: desactivada 31-08-2026, ver la ruta 'vincular-abono'.
// import { LinkMembershipCardComponent } from './components/link-membership-card/link-membership-card.component';
import { OwnerGuard } from './guards/owner.guard';
import { LegalComponent } from './components/shared/static-pages/legal/legal.component';
import { CookiesTermsComponent } from './components/shared/static-pages/cookies-terms/cookies-terms.component';
import { GenerateCanvasComponent } from './components/seat-map/generate-canvas/generate-canvas.component';
import { CreateMapComponent } from './components/seat-map/create-map/create-map.component';
import { CartCheckoutComponent } from './components/profile/cart-checkout/cart-checkout.component';
import { SeasonPassCheckoutComponent } from './components/profile/season-pass-checkout/season-pass-checkout.component';
import { PanelGuard } from './guards/panel.guard';
import { NewPasswordComponent } from './components/shared/new-password/new-password.component';
import { EventsPanelComponent } from './components/control-panel/events/events-panel/events-panel.component';
import { RouterEventsComponent } from './components/control-panel/events/router-events/router-events.component';
import { BondsComponent } from './components/control-panel/bonds/bonds.component';
import { DraftEventsComponent } from './components/control-panel/events/draft-events/draft-events.component';
import { CommentsEventComponent } from './components/control-panel/events/detail-event/comments-event/comments-event.component';
import { MailsEventComponent } from './components/control-panel/events/detail-event/mails-event/mails-event.component';
import { ReportsEventComponent } from './components/control-panel/events/detail-event/reports-event/reports-event.component';
import { OrdersEventComponent } from './components/control-panel/events/detail-event/orders-event/orders-event.component';
import { DiscountPassComponent } from './components/control-panel/events/detail-event/discount-pass/discount-pass.component';
import { DetailOrderComponent } from './components/control-panel/orders/detail-order/detail-order.component';
import { OrdersListComponent } from './components/control-panel/orders/orders-list/orders-list.component';
import { ConfigPanelComponent } from './components/control-panel/config/config-panel/config-panel.component';
import { RouterPermissionComponent } from './components/control-panel/config/permission/router-permission/router-permission.component';
import { UserPermissionComponent } from './components/control-panel/config/permission/user-permission/user-permission.component';
import { SubscribersListComponent } from './components/control-panel/subscribers/subscribers-list/subscribers-list.component';
import { NewsletterComponent } from './components/control-panel/subscribers/newsletter/newsletter.component';
import { SubscribersNotificationsComponent } from './components/control-panel/subscribers/subscribers-notifications/subscribers-notifications.component';
import { RouterBusinessComponent } from './components/control-panel/config/business/router-business/router-business.component';
import { HelpBusinessComponent } from './components/control-panel/config/business/help-business/help-business.component';
import { InfoProfileComponent } from './components/control-panel/config/info-profile/info-profile.component';
import { RouterVenueComponent } from './components/control-panel/config/venues/detail-venue/router-venue/router-venue.component';
import { VenuesListComponent } from './components/control-panel/config/venues/venues-list/venues-list.component';
import { InfoVenueComponent } from './components/control-panel/config/venues/detail-venue/info-venue/info-venue.component';
import { TicketsVenueComponent } from './components/control-panel/config/venues/detail-venue/tickets-venue/tickets-venue.component';
import { DiscountsVenueComponent } from './components/control-panel/config/venues/detail-venue/discounts-venue/discounts-venue.component';
import { MapVenueComponent } from './components/control-panel/config/venues/detail-venue/map-venue/map-venue.component';
import { EventsVenueComponent } from './components/control-panel/config/venues/detail-venue/events-venue/events-venue.component';
import { UserPurchasesComponent } from './components/control-panel/subscribers/user-purchases/user-purchases.component';
import { DocsVenueComponent } from './components/control-panel/config/venues/detail-venue/docs-venue/docs-venue.component';
import { ActivationControlComponent } from './components/control-panel/activation-control/activation-control.component';
import { FunctionsGuard } from './guards/functions.guard';
import { OrderEventComponent } from './components/control-panel/events/detail-event/order-event/order-event.component';
import { StatusPayComponent } from './components/checkout/status-pay/status-pay.component';
// Ruta comentada en el perfil (la pantalla no funciona); el componente sigue declarado en app.module.
// import { SubscriptionsComponent } from './components/profile/config/subscriptions/subscriptions.component';
import { CreateEventComponent } from './components/control-panel/events/create-event/create-event.component';
import { DiscountsCreateComponent } from './components/control-panel/events/components-create/discounts-create/discounts-create.component';
import { TicketsCreateComponent } from './components/control-panel/events/components-create/tickets-create/tickets-create.component';
import { MapSeatsCreateComponent } from './components/control-panel/events/components-create/map-seats-create/map-seats-create.component';
import { PaymentSuccessComponent } from './components/checkout/payment-success/payment-success.component';
import { PaymentErrorComponent } from './components/checkout/payment-error/payment-error.component';
import { RouterCreateComponent } from './components/control-panel/events/components-create/router-create/router-create.component';
import { UnsavedEventChangesGuard } from './guards/unsaved-event-changes.guard';
import { CreateVenueComponent } from './components/control-panel/config/venues/create-venue/create-venue.component';
import { SuperAdminGuard } from './guards/superadmin.guard';
import { BusinessComponent } from './components/control-panel/business/business.component';
import { TicketsProfileComponent } from './components/profile/config/tickets-profile/tickets-profile.component';
import { TicketDetailComponent } from './components/profile/config/ticket-detail/ticket-detail.component';
import { ReportsPageComponent } from './components/control-panel/reports-page/reports-page.component';
import { TotemGuard } from './guards/totem.guard';
import { WebGuard } from './guards/web.guard';
import { HomeTotemComponent } from './components/totem/home-totem/home-totem.component';
// Ruta comentada en el perfil (la pantalla no funciona); el componente sigue declarado en app.module.
// import { PaymentMethodsComponent } from './components/profile/config/payment-methods/payment-methods.component';
import { PassesListComponent } from './components/passes/passes-list/passes-list.component';
import { PassDetailComponent } from './components/passes/pass-detail/pass-detail.component';
import { PassPurchaseComponent } from './components/passes/pass-purchase/pass-purchase.component';
import { DiscountsListComponent } from './components/control-panel/discounts-list/discounts-list.component';
import { DiscountFormComponent } from './components/control-panel/discount-form/discount-form.component';
import { BondFormComponent } from './components/control-panel/bond-form/bond-form.component';
import { SeasonsListComponent } from './components/control-panel/sports-passes/seasons-list/seasons-list.component';
import { SeasonFormComponent } from './components/control-panel/sports-passes/season-form/season-form.component';
import { SeasonPassesListComponent } from './components/control-panel/sports-passes/season-passes-list/season-passes-list.component';
import { SeasonPassFormComponent } from './components/control-panel/sports-passes/season-pass-form/season-pass-form.component';
import { ProductsListComponent } from './components/control-panel/sports-passes/products-list/products-list.component';
import { ProductFormComponent } from './components/control-panel/sports-passes/product-form/product-form.component';
import { SeasonPassOrdersListComponent } from './components/control-panel/sports-passes/orders-list/orders-list.component';
import { SeasonPassOrderDetailComponent } from './components/control-panel/sports-passes/order-detail/order-detail.component';
import { PassCheckoutComponent } from './components/control-panel/sports-passes/pass-checkout/pass-checkout.component';
// Renovaciones del panel: desactivadas 31-08-2026, ver las rutas
// 'sports-passes/renewals'.
// import { LegacyRenewalsListComponent } from './components/control-panel/sports-passes/legacy-renewals-list/legacy-renewals-list.component';
// import { LegacyRenewalFormComponent } from './components/control-panel/sports-passes/legacy-renewal-form/legacy-renewal-form.component';

const pathDetailEvent: Routes = [
  {
    path: 'discount-event/:idEvent',
    component: DiscountPassComponent,
    title: 'Citylok - Descuentos y Abonos'
  },
  {
    path: 'order-event/:idEvent',
    component: OrdersEventComponent,
    title: 'Citylok - Pedidos del evento'
  },
  {
    path: 'order-event/:idEvent',
    children: [
      {
        path: 'order/:idOrder',
        component: OrderEventComponent,
        title: 'Citylok - Detalle pedido'
      }
    ]
  },
  {
    path: 'report-event/:idEvent',
    component: ReportsEventComponent,
    title: 'Citylok - Informes del evento'
  },
  {
    path: 'mailing-event/:idEvent',
    component: MailsEventComponent,
    title: 'Citylok - Envío de comunicaciones'
  },
  {
    path: 'comment-event/:idEvent',
    component: CommentsEventComponent,
    title: 'Citylok - Gestión de comentarios'
  },
  // Catch-all: información/lugar/config/multimedia/sesiones/entradas/config. de venta
  // reutilizan la misma pantalla que el creador de eventos (RouterCreateComponent),
  // diferenciadas por el valor de :step. Como es la misma ruta para todos los pasos,
  // Angular reutiliza la misma instancia del componente al cambiar solo el :step; hace
  // falta "paramsOrQueryParamsChange" para que el guard de cambios sin guardar
  // (canDeactivate) se vuelva a evaluar en cada cambio de pestaña.
  {
    path: ':step/:idEvent',
    component: RouterCreateComponent,
    canDeactivate: [UnsavedEventChangesGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    title: 'Citylok - Editar evento'
  },
];

const routes: Routes = [
  { path: '', component: HomeComponent, title: 'Citylok - Inicio', canActivate: [TotemGuard] },
  { path: 'inicio', component: HomeComponent, title: 'Citylok - Inicio', canActivate: [TotemGuard] },
  { path: 'home-totem', component: HomeTotemComponent, title: 'Citylok - Totem', canActivate: [WebGuard] },
  // { path: 'create-map', component: CreateMapComponent, title: 'Citylok - Crear Mapa' },
  { path: 'edit-map/:idMap', component: CreateMapComponent, title: 'Citylok - Editar Mapa', canActivate: [PanelGuard] },
  // { path: 'edit-event/map/:idMap', component: CreateMapComponent, title: 'Citylok - Editar Mapa', canActivate: [PanelGuard] },
  // { path: 'edit-event/map/:idMap/:idEvent', component: CreateMapComponent, title: 'Citylok - Editar Mapa', canActivate: [PanelGuard] },

  // Sign
  { path: 'login', component: LoginComponent, title: 'Citylok - Login', canActivate: [IsuserGuard, TotemGuard] },
  { path: 'signup', component: RegisterComponent, title: 'Citylok - Signup', canActivate: [IsuserGuard, TotemGuard] },
  { path: 'register/business', component: RegisterComponent, title: 'Citylok - Business', canActivate: [TotemGuard] },

  // Static page
  { path: 'privacy', component: PrivacyComponent, title: 'Citylok - Política de Privacidad' },
  { path: 'contact', component: ContactFormComponent, title: 'Citylok - Contacto' },
  { path: 'suggestions', component: SuggestionsComponent, title: 'Citylok - Sugerencias' },
  { path: 'terms-conditions', component: TermsConditionsComponent, title: 'Citylok - Términos y condiciones' },
  { path: 'faqs', component: FaqsComponent, title: 'Citylok - FAQs' },
  { path: 'about-us', component: AboutUsComponent, title: 'Citylok - ¿Quienes somos?', canActivate: [TotemGuard] },
  { path: 'quienes-somos', component: WhoWeAreComponent, title: 'Citylok - Quiénes somos', canActivate: [TotemGuard] },
  { path: 'cookies', component: CookiesTermsComponent, title: 'Citylok - Política de cookies' },
  { path: 'legal', component: LegalComponent, title: 'Citylok - Aviso legal' },
  // Alta de abonado. Camino único desde el 31-08-2026: hasta entonces los
  // socios migrados del sistema anterior renovaban por '/vincular-abono'
  // identificándose con la foto de su carné físico (LinkMembershipCardComponent).
  // Ese asistente sigue en el repo, solo desactivado; '/vincular-abono' está
  // impresa en material del club, así que la URL se mantiene viva como
  // redirect y quien llegue por ahí se da de alta como cualquier otro.
  //
  // Para reactivarlo: descomentar el import y la ruta de abajo, quitar el
  // redirect, y volver a declarar LinkMembershipCardComponent en app.module.
  //
  // { path: 'vincular-abono', component: LinkMembershipCardComponent, title: 'Citylok - Vincular mi abono', canActivate: [TotemGuard] },
  //
  // El plazo de altas se cerró el 28-09-2026 y el club lo REABRIÓ el
  // 05-10-2026, así que la ruta vuelve al asistente. La pantalla de cierre
  // (SeasonPassSignupClosedComponent) se queda en el repo, solo desactivada:
  // volver a cerrar es intercambiar estas dos líneas y declararla otra vez en
  // app.module. Hay que acordarse también de las rutas de
  // 'season-pass-signups' en la API, que se apagan y encienden a la vez.
  //
  // { path: 'alta-abono', component: SeasonPassSignupClosedComponent, title: 'Citylok - Altas de abonado cerradas', canActivate: [TotemGuard] },
  { path: 'alta-abono', component: SeasonPassSignupComponent, title: 'Citylok - Hazte abonado', canActivate: [TotemGuard] },
  { path: 'vincular-abono', redirectTo: 'alta-abono', pathMatch: 'full' },

  // Blog
  { path: 'cityblog', component: CityblogComponent, title: 'Cityblog' },
  { path: 'cityblog/:slug', component: DetailPodsComponent, title: 'Cityblog' },

  // Eventos
  { path: 'category/:nameCategory', component: CategoryPageComponent, canActivate: [TotemGuard] },
  { path: 'results', component: SearchComponent, title: 'Citylok - Resultados', canActivate: [TotemGuard] },
  { path: 'teatroideal', component: PageOwnerComponent, title: 'Citylok - Teatro ideal', canActivate: [TotemGuard] },
  // La pestaña de abonos del Teatro Ideal. Tiene que ir antes de
  // 'teatroideal/:date/:shortUrl' aunque no colisionen (uno vs. dos segmentos),
  // para dejar claro que 'abonos' es una pestaña y no una fecha.
  { path: 'teatroideal/abonos', component: PageOwnerComponent, title: 'Citylok - Teatro ideal', canActivate: [TotemGuard] },
  { path: 'teatroideal/:date/:shortUrl', component: EventComponent, canActivate: [TotemGuard] },
  // { path: 'events/:idOwner/:ownerEvent', component: PageOwnerComponent },
  { path: 'events/:pathUrl', component: PageOwnerComponent },
  { path: 'events/:pathUrl/abonos', component: PageOwnerComponent },
  { path: 'venue/:pathUrl', component: PageOwnerComponent },
  { path: 'venue/:pathUrl/abonos', component: PageOwnerComponent },
  { path: 'event/:slugEvent', component: EventComponent, title: 'Citylok - Eventos' },
  { path: 'draft/event/:slugEvent', component: EventComponent, title: 'Citylok - Eventos', canActivate: [TotemGuard] },
  { path: 'event/:slugEvent/:comments', component: EventComponent, title: 'Citylok - Eventos', canActivate: [TotemGuard] },

  // Abonos (Passes)
  { path: 'abonos', component: PassesListComponent, title: 'Citylok - Abonos', canActivate: [TotemGuard] },
  { path: 'abonos/:id', component: PassDetailComponent, title: 'Citylok - Detalle Abono', canActivate: [TotemGuard] },
  { path: 'abonos/:id/comprar', component: PassPurchaseComponent, title: 'Citylok - Comprar Abono', canActivate: [AuthGuard, TotemGuard] },

  // Checkout
  { path: 'cart-checkout', component: CartCheckoutComponent, title: 'Citylok - Cart Checkout', canActivate: [AuthGuard] },
  { path: 'abono-checkout/:id', component: SeasonPassCheckoutComponent, title: 'Citylok - Pago del abono', canActivate: [AuthGuard] },
  { path: 'checkout', component: CheckoutPageComponent, title: 'Citylok - Checkout', canActivate: [CheckoutGuard, TotemGuard] },
  {
    path: 'checkout',
    children: [
      {
        path: 'validate',
        canActivate: [CheckoutGuard, TotemGuard],
        component: CheckoutPageComponent
      },
      {
        path: 'payment',
        canActivate: [AuthGuard, TotemGuard],
        component: CheckoutPageComponent
      },
      {
        path: 'payment',
        children: [
          {
            path: 'card',
            canActivate: [AuthGuard, TotemGuard],
            component: CheckoutPageComponent
          },
        ]
      },
      {
        path: 'pay/success',
        canActivate: [TotemGuard],
        component: PaymentSuccessComponent
      },
      {
        path: 'pay/failed',
        canActivate: [TotemGuard],
        component: PaymentErrorComponent
      }


    ]
  },

  { path: 'user/favorites', component: FavoritesComponent, title: 'Citylok - Favoritos', canActivate: [AuthGuard, TotemGuard] },

  // User
  { path: 'profile', component: ProfileComponent, title: 'Citylok - Perfil', canActivate: [AuthGuard, TotemGuard] },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard, TotemGuard],
    children: [
      {
        path: 'mis-datos',
        component: EditProfileComponent,
        title: 'Citylok - Mis datos'
      },
      // Intereses por ciudad: la pantalla existe pero no llega a hacer nada,
      // así que se retira del perfil hasta que se implemente de verdad. El
      // componente se queda en el repo a propósito.
      // {
      //   path: 'preferences',
      //   component: InteresesComponent,
      //   title: 'Citylok - Preferencias'
      // },
      {
        path: 'seat-maps',
        component: ProfileComponent,
        title: 'Citylok - Perfil - Mapas'
      },
      {
        path: 'drafts',
        component: ProfileComponent,
        title: 'Citylok - Perfil - Borradores'
      },
      // Suscripciones a espacios: misma historia, no funciona.
      // {
      //   path: 'subscriptions',
      //   component: SubscriptionsComponent,
      //   title: 'Citylok - Preferencias'
      // },
      {
        path: 'ayuda',
        component: FaqsComponent,
        title: 'Citylok - Ayuda y FAQs'
      },
      {
        path: 'entradas',
        component: TicketsProfileComponent,
        title: 'Citylok - Mis entradas'
      },
      {
        // La pantalla de una entrada. No es compartible: la API acota el
        // pedido al usuario de la sesión, así que este enlace no le abre
        // nada a nadie más.
        //
        // El pedido va en la ruta y el evento en la query (?event=&session=),
        // porque un pedido puede traer varios eventos. Los parámetros se
        // quedan en inglés aunque la ruta esté en español: son los nombres de
        // la API y de la BD.
        path: 'entradas/:order',
        component: TicketDetailComponent,
        title: 'Citylok - Entrada'
      },
      // Métodos de pago guardados: Redsys no llega a guardarlos, la pantalla
      // sale siempre vacía.
      // {
      //   path: 'pay_methods',
      //   component: PaymentMethodsComponent,
      //   title: 'Citylok - Metodos de pago'
      // },
      {
        path: 'notificaciones',
        component: NotificationsComponent,
        title: 'Citylok - Notificaciones'
      },
      // Las rutas de antes, que no se pueden retirar: el correo de
      // recordatorio de evento enlaza a profile/tickets y a
      // profile/notifications, y hay correos ya enviados en bandejas de
      // entrada. Angular conserva la query al redirigir, así que el
      // ?event=&session= de una entrada llega entero.
      { path: 'tickets', redirectTo: 'entradas', pathMatch: 'full' },
      { path: 'tickets/:order', redirectTo: 'entradas/:order' },
      { path: 'purchases', redirectTo: 'entradas', pathMatch: 'full' },
      { path: 'edit', redirectTo: 'mis-datos', pathMatch: 'full' },
      { path: 'notifications', redirectTo: 'notificaciones', pathMatch: 'full' },
      { path: 'faqs', redirectTo: 'ayuda', pathMatch: 'full' },
      {
        path: 'abonos',
        component: MyMembershipComponent,
        title: 'Citylok - Mis abonos deportivos',
        children: [
          {
            path: ':id/carnet',
            component: AbonoCardComponent,
            title: 'Citylok - Carnet digital'
          }
        ]
      },
      {
        path: '',
        redirectTo: 'tickets',
        pathMatch: 'full'
      },
    ]
  },
  // Panel de Control
  { path: 'panel-control', component: EventsPanelComponent, title: 'Citylok - Panel de Control', canActivate: [AuthGuard, TotemGuard], data: { accessRoles: ["ROLE_GESTOR"] } },
  {
    path: 'panel-control',
    canActivate: [AuthGuard, TotemGuard],
    children: [
      {
        path: 'list-business',
        component: BusinessComponent,
        title: 'Citylok - Empresas',
        canActivate: [SuperAdminGuard, AuthGuard]
      },
      {
        path: 'events',
        component: EventsPanelComponent,
        title: 'Citylok - Eventos',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_EXTERN_EVENTS", "ACCESS_ADMIN", "ACCESS_MANAGER", "CREATE_EVENTS", "ACCESS_REPORTS", "ACCESS_SALES", "ACCESS_MARKETING", "ACCESS_SUPPORT", "ACCESS_QR_APP"]
        }
      },
      {
        path: 'events',
        canActivate: [AuthGuard],
        children: [
          {
            path: 'list',
            component: EventsPanelComponent,
            title: 'Citylok - Información del Evento'
          },
          {
            path: 'draft',
            component: DraftEventsComponent,
            title: 'Citylok - Borradores',
            canActivate: [FunctionsGuard, AuthGuard],
            data: {
              accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
            },
          },
          {
            path: 'bonds',
            component: BondsComponent,
            title: 'Citylok - Abonos',
            canActivate: [FunctionsGuard, AuthGuard],
            data: {
              accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
            },
          },
          // Unicamente lo verán los creadores de eventos
          {
            path: 'draft/detail',
            canActivate: [FunctionsGuard, AuthGuard],
            data: {
              accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
            },
            children: pathDetailEvent
          },
        ]
      },
      {
        path: 'events/detail',
        canActivate: [AuthGuard],
        children: pathDetailEvent
      },
      {
        path: 'events/create',
        canActivate: [AuthGuard],
        component: CreateEventComponent,
      },
      {
        path: 'events/new-event',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        },
        children: [
          {
            path: ':step',
            component: RouterCreateComponent,
            title: 'Citylok - Creación de Evento',
          },
          {
            path: ':step',
            children: [{
              path: ':idEvent',
              component: RouterCreateComponent,
              title: 'Citylok - Creación de Evento',
            }]
          },
        ]
      },
      // Abonos management (top-level)
      {
        path: 'bonds',
        component: BondsComponent,
        title: 'Citylok - Abonos',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        }
      },
      {
        path: 'bonds/create',
        component: BondFormComponent,
        title: 'Citylok - Nuevo Abono',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        }
      },
      {
        path: 'bonds/edit/:id',
        component: BondFormComponent,
        title: 'Citylok - Editar Abono',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        }
      },
      // Discounts management
      {
        path: 'discounts',
        component: DiscountsListComponent,
        title: 'Citylok - Descuentos',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        }
      },
      {
        path: 'discounts/create',
        component: DiscountFormComponent,
        title: 'Citylok - Crear Descuento',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        }
      },
      {
        path: 'discounts/edit/:id',
        component: DiscountFormComponent,
        title: 'Citylok - Editar Descuento',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        }
      },
      // Sports passes management (Abonos de temporada)
      {
        path: 'sports-passes',
        redirectTo: 'sports-passes/passes',
        pathMatch: 'full'
      },
      {
        path: 'sports-passes/passes',
        component: SeasonPassesListComponent,
        title: 'Citylok - Abonos de temporada',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        }
      },
      {
        path: 'sports-passes/passes/create',
        component: SeasonPassFormComponent,
        title: 'Citylok - Nuevo Abono',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        }
      },
      {
        path: 'sports-passes/passes/edit/:passId',
        component: SeasonPassFormComponent,
        title: 'Citylok - Editar Abono',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        }
      },
      {
        path: 'sports-passes/passes/checkout/:passId',
        component: PassCheckoutComponent,
        title: 'Citylok - Cobro de Abono',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        }
      },
      // DESACTIVADO 31-08-2026 — renovación de abonados migrados del sistema
      // anterior desde el panel. Los componentes siguen en el repo
      // (legacy-renewals-list/, legacy-renewal-form/); para reactivarlo,
      // descomentar estas rutas y sus imports, volver a declarar los dos
      // componentes en control-panel.module y devolver la pestaña
      // "Renovaciones" al submenú de abonos.
      //
      // {
      //   path: 'sports-passes/renewals',
      //   component: LegacyRenewalsListComponent,
      //   title: 'Citylok - Renovaciones de abonados',
      //   canActivate: [FunctionsGuard, AuthGuard],
      //   data: {
      //     accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
      //   }
      // },
      // {
      //   path: 'sports-passes/renewals/:memberNumber',
      //   component: LegacyRenewalFormComponent,
      //   title: 'Citylok - Renovar Abonado',
      //   canActivate: [FunctionsGuard, AuthGuard],
      //   data: {
      //     accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
      //   }
      // },
      {
        path: 'sports-passes/seasons',
        component: SeasonsListComponent,
        title: 'Citylok - Temporadas',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        }
      },
      {
        path: 'sports-passes/seasons/create',
        component: SeasonFormComponent,
        title: 'Citylok - Nueva Temporada',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        }
      },
      {
        path: 'sports-passes/seasons/edit/:id',
        component: SeasonFormComponent,
        title: 'Citylok - Editar Temporada',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        }
      },
      {
        path: 'sports-passes/orders',
        component: SeasonPassOrdersListComponent,
        title: 'Citylok - Pedidos de abono',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        }
      },
      {
        path: 'sports-passes/orders/:id',
        component: SeasonPassOrderDetailComponent,
        title: 'Citylok - Detalle de pedido',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        }
      },
      {
        path: 'sports-passes/products',
        component: ProductsListComponent,
        title: 'Citylok - Productos de abono',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        }
      },
      {
        path: 'sports-passes/products/create',
        component: ProductFormComponent,
        title: 'Citylok - Nuevo Producto',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        }
      },
      {
        path: 'sports-passes/products/edit/:id',
        component: ProductFormComponent,
        title: 'Citylok - Editar Producto',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
        }
      },
      {
        path: 'reports',
        component: ReportsPageComponent,
        title: 'Citylok - Informes',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS", "ACCESS_REPORTS", "ACCESS_SALES"]
        }
      },
      {
        path: 'orders',
        component: OrdersListComponent,
        title: 'Citylok - Pedidos',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS", "ACCESS_REPORTS", "ACCESS_SALES", "ACCESS_SUPPORT"]
        }
      },
      {
        path: 'orders',
        children: [
          {
            path: 'list',
            component: OrdersListComponent,
            title: 'Citylok - Listado de pedidos'
          },
          {
            path: 'billing',
            component: DetailOrderComponent,
            title: 'Citylok - Facturación'
          }
        ]
      },
      {
        path: 'orders/detail',
        children: [
          {
            path: 'info-order',
            component: DetailOrderComponent,
            title: 'Citylok - Información del pedido'
          },
        ]
      },
      {
        path: 'subscribers',
        component: UserPurchasesComponent,
        title: 'Citylok - Listado de usuarios',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "ACCESS_MARKETING", "ACCESS_SUPPORT"]
        }
      },
      {
        path: 'subscribers',
        children: [
          {
            path: 'list-users',
            component: UserPurchasesComponent,
            title: 'Citylok - Listado de usuarios'
          },
          {
            path: 'list-subscribers',
            component: SubscribersListComponent,
            title: 'Citylok - Listado de socios'
          },
          {
            path: 'comments',
            component: NewsletterComponent,
            title: 'Citylok - Comentarios'
          },
          {
            path: 'newsletter',
            component: NewsletterComponent,
            title: 'Citylok - Newsletter'
          },
          {
            path: 'notifications',
            component: SubscribersNotificationsComponent,
            title: 'Citylok - Notificaciones'
          },
        ]
      },
      {
        path: 'config',
        component: ConfigPanelComponent,
        title: 'Citylok - Configuración',
        // canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_EXTERN_EVENTS", "ACCESS_ADMIN", "ACCESS_MANAGER", "CREATE_EVENTS", "ACCESS_REPORTS", "ACCESS_SALES", "ACCESS_MARKETING", "ACCESS_SUPPORT", "ACCESS_QR_APP"]
        }
      },
      {
        path: 'config',
        children: [
          {
            path: 'venues',
            component: VenuesListComponent,
            title: 'Citylok - Espacios',
            canActivate: [FunctionsGuard],
            data: {
              accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
            }
          },
          {
            path: 'create-venue',
            component: CreateVenueComponent,
            title: 'Citylok - Crear Espacio',
            canActivate: [FunctionsGuard],
            data: {
              accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
            }
          },
          {
            path: 'map-venue',
            component: CreateMapComponent,
            title: 'Citylok - Crear Mapa de butacas',
            canActivate: [FunctionsGuard],
            data: {
              accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN", "CREATE_EVENTS"]
            }
          },
          {
            path: 'business',
            component: RouterBusinessComponent,
            title: 'Citylok - Organización',
            canActivate: [FunctionsGuard],
            data: {
              accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_EXTERN_EVENTS", "ACCESS_ADMIN"]
            }
          },
          {
            path: 'permission',
            component: RouterPermissionComponent,
            title: 'Citylok - Permisos y gestores',
            canActivate: [FunctionsGuard],
            data: {
              accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_EXTERN_EVENTS", "ACCESS_ADMIN"]
            }
          },
          {
            path: 'info-profile',
            component: InfoProfileComponent,
            title: 'Citylok - Perfil de usuario',
            // canActivate: [FunctionsGuard],
            data: {
              accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_EXTERN_EVENTS", "ACCESS_ADMIN", "ACCESS_MANAGER", "CREATE_EVENTS", "ACCESS_REPORTS", "ACCESS_SALES", "ACCESS_MARKETING", "ACCESS_SUPPORT", "ACCESS_QR_APP"]
            }
          },
        ]
      },
      {
        path: 'config/venues',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_ADMIN"]
        },
        children: [
          {
            path: 'info-venue/:idVenue',
            component: InfoVenueComponent,
            title: 'Citylok - Permisos y gestores'
          },
          {
            path: 'tickets-venue/:idVenue',
            component: TicketsVenueComponent,
            title: 'Citylok - Permisos y gestores'
          },
          {
            path: 'discounts-venue/:idVenue',
            component: DiscountsVenueComponent,
            title: 'Citylok - Permisos y gestores'
          },
          {
            path: 'map-venue/:idVenue',
            component: MapVenueComponent,
            title: 'Citylok - Permisos y gestores'
          },
          {
            path: 'create-map/:idVenue',
            component: MapVenueComponent,
            title: 'Citylok - Crear Mapa de butacas'
          },
          {
            path: 'event-venue/:idVenue',
            component: EventsVenueComponent,
            title: 'Citylok - Permisos y gestores'
          },
          {
            path: 'docs-venue/:idVenue',
            component: DocsVenueComponent,
            title: 'Citylok - Documentos'
          }
        ]
      },
      {
        path: 'config/permission',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_EXTERN_EVENTS", "ACCESS_ADMIN"]
        },
        children: [
          {
            path: 'function',
            component: RouterPermissionComponent,
            title: 'Citylok - Permisos y gestores'
          },
          {
            path: 'function/user/:idUser',
            component: UserPermissionComponent,
            title: 'Citylok - Permisos y gestores'
          }
        ]
      },
      {
        path: 'config/help',
        component: HelpBusinessComponent,
        title: 'Citylok - Ayuda',
        canActivate: [AuthGuard]
      },
      {
        path: 'config/business',
        canActivate: [FunctionsGuard, AuthGuard],
        data: {
          accessRoles: ["admin","superadmin","ACCESS_CLOUD", "ACCOUNT_OWNER", "ACCESS_EXTERN_EVENTS", "ACCESS_ADMIN"]
        },
        children: [
          {
            path: ':typePage',
            component: RouterBusinessComponent,
            title: 'Citylok - Organización'
          },
        ]
      },
    ]
  },
  { path: 'activation_control', component: ActivationControlComponent, canActivate: [TotemGuard] },


  { path: 'reset/password', component: NewPasswordComponent, canActivate: [TotemGuard] },
  { path: '**', component: NotFoundPageComponent, title: 'Not Found' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
